import React from 'react';

const data = {
    title: "개인정보 처리 방침"
    ,prefix: "{i}"
    ,body: "다음 개인정보 처리 방침(이하 방침)은 이 서비스에서 수집하거나 제공하는 개인정보를 처리하는 방법에 대해 설명합니다. 또한 이 방침은 서비스를 이용하는 과정에서 어떤 개인정보를 수집하거나 제공하는지 설명합니다. 오늘의 웹툰은 본 서비스와 연관 서비스로의 개인정보 수집과 처리의 주체입니다. 이 방침을 통해 오늘의 웹툰은 유저의 개인정보의 중요성을 표하고, 개인정보를 활용하는 방법과 목적, 어떤 방법으로 개인정보를 보호하는지를 고지합니다."
    ,nested: [
        {
            title: "수집된 정보의 사용"
            , prefix: "-"
            , body: "오늘의 웹툰은 다음의 목적으로 정보를 수집합니다:"
            , nested: [
                {title: "회원 관리와 식별"},
                {title: "서비스 개선과 신규 기능 개발"},
                {title: "법적 의무 및 유관 법률 준수", prefix: '-'}
            ]
        },
        {
            title: "수집된 정보의 노출"
            , prefix: "-"
            , body: "오늘의 웹툰은 그 어떤 개인정보도 제 3자에게 제공하지 않습니다."
            , nested: [
            ]
        },
        {
            title: "사용자의 권리"
            , prefix: "-"
            , body: "사용자 또는 그의 법적 대리인은 개인정보의 주체로서, 오늘의 웹툰에서 발생하는 개인정보 수집, 사용 및 공유에 대해 다음과 같이 권리를 행사할 수 있습니다:"
            , nested: [
                {title: "개인정보 조회에 대한 권리"},
                {title: "기존에 동의한 사항을 취소할 권리"},
                {title: "개인정보 처리를 일시적으로 중지할 권리"},
                {
                    title: "개인 정보를 삭제할 권리:",
                    prefix:'-',
                    nested: [
                        {title: "개인정보를 삭제하길 원하는 경우, '내 정보 페이지'에서 회원 탈퇴 신청을 해주시기 바랍니다. 요청 즉시, 회사는 관련 법령과 규정에 근거하여 당신의 모든 개인정보를 삭제합니다.", prefix: '-'},
                        {title: "개인정보를 제외하고 서비스를 통해 게시한 당신의 모든 정보는 정보 옆에 있는 '삭제' 버튼을 통해 즉시 삭제를 요청할 수 있습니다.", prefix: '-'}
                    ]
                }
            ]
        },
        {
            title: "수집되는 개인정보 및 이를 수집하는 방법"
            , prefix: "-"
            , body: "오늘의 웹툰은 다음과 같은 사항을 수집합니다:"
            , nested: [
                {title: "암호화된 Google 식별자, Email, name(Google SSO를 사용하는 경우)"},
                {title: "암호화된 Facebook 식별자, Email, name(Facebook SSO를 사용하는 경우)"},
                {title: "브라우저의 고유 명칭(user agent)"},
                {title: "접속 주소(IP)"},
                {title: "서비스를 사용하면서 발생한 상호작용 정보"},
            ]
        },
        {
            title: "구글 사용자 정보의 수집과 목적"
            , prefix: "-"
            , body: "오늘의 웹툰은 아래 표기된 목적과 방법으로 구글 사용자 정보를 수집합니다:"
            , nested: [
                {title: "구글 로그인(Google SSO)과정을 통해"},
                {title: "제한된 범위의 사용자 정보(user id, name, email)를 수집합니다. 이는"},
                {title: "사용자를 다른 이들과 구분짓기 위함이며"},
                {title: "개인화된 추천을 제공하기 위함입니다."},
                {title: "오늘은 구글로부터 제공받은 어떠한 정보도 외부로 공유하지 않습니다."},
            ]
        },
        {
            title: "보안"
            , prefix: "-"
            , body: "오늘의 웹툰은 개인정보 보안이 매우 중요하다고 인지하고 있습니다. 오늘의 웹툰은 다음과 같은 보안 방법을 구축하여 비인가 접근, 배포, 사용 또는 변형으로부터 개인정보를 보호하고 있습니다."
            , nested: [
                {title: "개인정보의 암호화", prefix: '-'},
                {title: "해킹 역탐지", prefix: '-'},
            ]
        },
        {
            title: "쿠키 및 유사 기술"
            , prefix: "-"
            , body: "오늘의 웹툰은 쿠키를 이용하여 웹서비스 사용 정보를 수집합니다. 유저는 쿠키 수집에 대해 선택권이 있습니다. 브라우저 설정을 통해 사이트의 모든 쿠키 수집을 차단할 수 있으며, 저장된 시점에 무엇이 저장되었는지를 확인하거나 저장되지 않도록 할 수 있습니다: 설명한 바와 같이, 쿠키를 사용하지 않도록 하는 것은 사용자를 식별하기 어렵게 만들며 온전한 서비스를 제공받을 수 없음을 의미합니다."
            , nested: [
            ]
        },
        {
            title: "연락 정보"
            , prefix: "-"
            , body: "오늘의 웹툰이 이 방침에 따라 처리해야 하는 문의사항이 있거나, 개인정보에 대한 권리를 행사하는 경우 아래의 연락처로 문의주세요:"
            , nested: [
                {title: "privacy@webtoon.today"}
            ]
        },
    ]
};
/*
        {
            title: ""
            , prefix: ""
            , body: ""
            , nested: [
            ]
        }
 */

const DrawData = (data, prefix, depth, idx) => {

    const romanNumber = ['i', 'ii', 'iii', 'iv', 'v', 'vi', 'vii', 'viii', 'ix'];

    if (typeof(data) === 'string'){
        
        return (
            <div style={{paddingLeft: 20, fontSize: 120*Math.pow(0.9, depth)+'%' }}>
                <p>
                {prefix?`${prefix.replace('{n}',idx+1).replace('{i}', 'x'.repeat(Math.floor(idx/10))+romanNumber[idx%10] )}`:''} {data || ""}
                </p>
            </div>
        );
    };

    return (
        <div style={{paddingLeft: 20, fontSize: 120*Math.pow(0.9, depth)+'%' }}>
            <p>
                {prefix?`${prefix.replace('{n}',idx+1).replace('{i}', 'x'.repeat(Math.floor(idx/10))+romanNumber[idx%10] )}`:''} {data.title || ""}
            </p>
            {data.body || ""}
            {data.nested?data.nested.map( (row,idx) => DrawData(row, data.prefix, depth+1, idx )):''}
        </div>
    );
}
        


export default function AnalyticsTermsOfUseKr (props) {

    window.canonicalPath = '/termsofuse/analytics/kr';
    document.title = "개인정보 처리정책";

    return (
        <div style={{textAlign:'left', wordBreak: 'keep-all', padding: 30}}>
            {DrawData(data, "", 1)}
        </div>
    );
}